import React from 'react';
import { useRouteMatch, Switch, Redirect } from 'react-router-dom';
import AuthorizedRoute from 'routes/AuthorizedRoute';
import { DASHBOARD_RESOURCES, DASHBOARD_SCOPES, PAGE_NAMES } from 'constant';

import ListHomePageLayout from './submodules/list';
import ListLayout from './submodules/layout';
import CreateLayout from './submodules/create';
import CreateLayoutOrder from './submodules/layout/create';
import EditLayoutOrder from './submodules/layout/edit';
import EditLayouts from './submodules/edit';

const HomePageDashboard: React.FC<{}> = () => {
	const { path } = useRouteMatch();

	return (
		<Switch>
			<AuthorizedRoute
				entity={DASHBOARD_RESOURCES.homePageLayout}
				actions={[DASHBOARD_SCOPES[DASHBOARD_RESOURCES.homePageLayout].getVersionSupportedHomepageLayout]}
				configPageName={PAGE_NAMES.dashboard}
				path={`${path}/list`}
				component={ListHomePageLayout}
				exact
			/>
			<AuthorizedRoute
				entity={DASHBOARD_RESOURCES.homePageLayout}
				actions={[DASHBOARD_SCOPES[DASHBOARD_RESOURCES.homePageLayout].editLayouts]}
				configPageName={PAGE_NAMES.dashboard}
				path={`${path}/edit`}
				component={EditLayouts}
				exact
			/>
			<AuthorizedRoute
				entity={DASHBOARD_RESOURCES.homePageLayout}
				actions={[DASHBOARD_SCOPES[DASHBOARD_RESOURCES.homePageLayout].createLayoutOrder]}
				configPageName={PAGE_NAMES.dashboard}
				path={`${path}/layout/create`}
				component={CreateLayoutOrder}
				exact
			/>
			<AuthorizedRoute
				entity={DASHBOARD_RESOURCES.homePageLayout}
				actions={[DASHBOARD_SCOPES[DASHBOARD_RESOURCES.homePageLayout].editLayoutOrder]}
				configPageName={PAGE_NAMES.dashboard}
				path={`${path}/layout/edit`}
				component={EditLayoutOrder}
				exact
			/>
			<AuthorizedRoute
				entity={DASHBOARD_RESOURCES.homePageLayout}
				actions={[DASHBOARD_SCOPES[DASHBOARD_RESOURCES.homePageLayout].createLayout]}
				configPageName={PAGE_NAMES.dashboard}
				path={`${path}/create`}
				component={CreateLayout}
				exact
			/>
			<AuthorizedRoute
				entity={DASHBOARD_RESOURCES.homePageLayout}
				actions={[DASHBOARD_SCOPES[DASHBOARD_RESOURCES.homePageLayout].getVersionSupportedHomepageLayout]}
				configPageName={PAGE_NAMES.dashboard}
				path={`${path}/layout`}
				component={ListLayout}
				exact
			/>
			<Redirect to={`${path}/list`} />
		</Switch>
	);
};

export default HomePageDashboard;
